/* Admin user roster + persona-assignment endpoints (persona-foundation
 * Task 4). GET /users already existed (Phase 0 auth roster) and is fetched
 * inline by state/workspace.ts's init() for the assign-picker roster
 * (ws.users) — that copy is fetched once per client-board load and would
 * show stale persona chips after an edit, so the admin Users panel (ws/
 * adminUsers.ts) uses this own on-demand wrapper instead of reading ws.users.
 *
 * PATCH /users/{id}/personas is NEW (Task 2 backend, service/app/routers/
 * auth.py): admin-only (require_admin), validates against the closed
 * PERSONAS/MGMT_DEPARTMENTS vocabularies server-side and 422s on a bad
 * shape; a non-admin caller gets a 403 ApiError the same way every other
 * admin-gated write in this hub surfaces one.
 */
import { request } from './client.ts';
import type { AuthUser } from '../lib/auth.ts';
import type { PersonaRow } from '../lib/personas.ts';

/** GET /users — the full roster (id/email/name/picture_url/role/personas/
 * primary_persona per row). */
export function getUsers(): Promise<AuthUser[]> {
  return request<{ users?: AuthUser[] }>('/users').then((r) => r.users || []);
}

/** PATCH /users/{id}/personas — atomically replaces the user's persona set.
 * `primary` is the colon-encoded capacity string (lib/personas.ts's
 * capacityKey): 'bizdev' | 'am' | 'writer' | 'management:<dept>'. */
export function setUserPersonas(
  userId: number,
  personas: PersonaRow[],
  primary: string,
): Promise<{ user: AuthUser }> {
  return request<{ user: AuthUser }>(`/users/${userId}/personas`, {
    method: 'PATCH',
    body: JSON.stringify({ personas, primary_persona: primary }),
  });
}
